const NoForm = () => <p>No Forms to complete</p>;

export default NoForm;
